// Actions
export const GET_COPILOT_INDICATORS = 'copilot_audit/GET_COPILOT_INDICATORS'
export const GET_COPILOT_AUDIT = 'copilot_audit/GET_COPILOT_AUDIT'
